export enum GTMEvent {
  PortalClick = 'embrace_portal_click',
  PortalError = 'embrace_portal_error'
}

export enum GTMClickType {
  CTA = 'cta',
  Radio = 'radio',
  Submit = 'submit'
}

export enum GTMClickLocation {
  Card = 'card',
  Carousel = 'carousel',
  ContentTop = 'content_top',
  Navigation = 'navigation'
}